export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["SELECTING"] = "SELECTING";
    PaymentStatus["SUCCESS"] = "SUCCESS";
    PaymentStatus["ERROR"] = "ERROR";
})(PaymentStatus || (PaymentStatus = {}));
